import React, { memo } from 'react'
import { LOADER } from 'utils/constants/index'
import { getDocumentThemeSlug } from 'theme/themes'
import './Loader.scss'

const Loader = ({ component }) => {
  switch (component) {
    case LOADER.CONTENT:
      return (
        <div className='d-flex justify-content-center mt-2 mb-2'>
          <div className='spinner-border text-light mt-2 mb-2' role='status'>
            <span className='sr-only'>Loading...</span>
          </div>
        </div>
      )

    case LOADER.TABLE_CELL:
      return <span className='spinner-border spinner-border-sm text-light' role='status' aria-hidden='true' />

    case LOADER.BUTTON:
      return <span className='spinner-border spinner-border-sm text-light' role='status' aria-hidden='true' />

    default: {
      // Prefer document theme when Suspense runs (body class may already be set).
      const themeSlug = getDocumentThemeSlug()
      return (
        <div
          className={`position-fixed inset-0 d-flex justify-content-center align-items-center show-loader${themeSlug ? ` ${themeSlug}` : ''}`}
          role='status'
          aria-label='Loading'
        >
          <div className='spinner-border' aria-hidden='true' />
        </div>
      )
    }
  }
}

export default memo(Loader)
